import { normalizeFilters } from '../../../shared/lib/normalizeFilters'
import { GewerkFilters } from '@myapp/contract'

export const gewerkKeys = {
  all: ['gewerk'] as const,

  lists: () => [...gewerkKeys.all, 'list'] as const,

  list: (filters?: GewerkFilters) =>
    [...gewerkKeys.lists(), normalizeFilters(filters)] as const,

  details: () => [...gewerkKeys.all, 'detail'] as const,

  detail: (id: number) =>
    [...gewerkKeys.details(), id] as const,
}
